export const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/register',
  '/login-firebase',
  '/forgot-password',
  '/reset-password',
  '/maintenance',
  '/document-not-found',
  '/unauthorized-access',
  '/session-expired',
  '/forbidden',
  '/signature-signing'
] as const

export const AUTH_ROUTES = [
  '/login',
  '/register',
  '/login-firebase'
] as const

